export var GET_PERMISSIONS = 'appspotr/Permissions/GET_PERMISSIONS';
export var GET_PERMISSIONS_REQUEST = 'app/SidebarPage/GET_PERMISSIONS_REQUEST';
export var GET_PERMISSIONS_SUCCESS = 'app/SidebarPage/GET_PERMISSIONS_SUCCESS';
export var GET_PERMISSIONS_FAILURE = 'app/SidebarPage/GET_PERMISSIONS_FAILURE';
export var CLEAR_PERMISSIONS = 'app/SidebarPage/CLEAR_PERMISSIONS';
